// src/components/Academics.jsx
import { Box, Typography, Container, Paper } from "@mui/material";
import SchoolIcon from "@mui/icons-material/School";
import { motion } from "framer-motion";
import education from "../data/education"; // Import from your data file

const Academics = () => {
  return (
    <Box id="academics" sx={{ py: 8, bgcolor: "background.default" }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h4" gutterBottom align="center">
            Education
          </Typography>
          {education.map((edu, index) => (
            <Paper key={index} elevation={3} sx={{ p: 4, mb: 4 }}>
              <Box display="flex" alignItems="center" mb={2}>
                <SchoolIcon color="primary" sx={{ mr: 2 }} />
                <Box>
                  <Typography variant="h6">{edu.degree}</Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {edu.institution} • {edu.duration}
                  </Typography>
                </Box>
              </Box>
              {edu.board && (
                <Typography className="ms-5">{edu.board}</Typography>
              )}
              {edu.semester && (
                <Typography className="ms-5">{edu.semester}</Typography>
              )}
              {edu.credit && (
                <Typography className="ms-5">{edu.credit}</Typography>
              )}
              <Typography className="ms-5">{edu.gpa}</Typography>
            </Paper>
          ))}
        </motion.div>
      </Container>
    </Box>
  );
};

export default Academics;
